import * as React from 'react';
import FormLabel from "@mui/material/FormLabel";
import { Autocomplete, TextField, FormControl, FormHelperText } from '@mui/material';

export default function AutocompleteCom({ ...other }) {
  const [valueSelect, setValueSelect] = React.useState(null);
  const [inputValueSelect, setInputValueSelect] = React.useState("");
  const [error, setError] = React.useState(false); // Estado para el error

  const handleChange = (event, newValue) => {
    if (newValue) {
      other.setDataId(newValue.id);
      setError(false); // Desactivar el estado de error si hay un valor
    } else {
      other.setDataId(null);
      setError(true); // Activar el estado de error si no hay valor
    }
    setValueSelect(newValue);
  };
  return (
    <>
      <FormControl error={other.error} fullWidth variant="outlined">
        <FormLabel htmlFor={other.FormLabel} required>
          {other.FormLabel}
        </FormLabel>
        <Autocomplete
          size={other.size}
          value={valueSelect}
          onChange={handleChange}
          disabled={other.disabled}
          inputValue={inputValueSelect}
          onInputChange={(event, newInputValue) => {
            setInputValueSelect(newInputValue);
          }}
          sx={{ width: '100%' }} // Hacer que ocupe el 100% del ancho del contenedor padre
          id={other.id}
          options={other.options}
          getOptionLabel={(option) => option.name || ""}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              placeholder={other.Favorites}
              {...params}
              label={other.label}
              key={params.key} // Agregar una clave única aquí también
              error={other.error} // Pasar el estado de error al TextField
              helperText={other.error ? other.errorMessage : ""} // Mensaje de error si hay un error
            />
          )}
        />
      </FormControl>
    </>
  );
}
